import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-success d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pe-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-undo" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "Dieser Kurs ist krankenkassenzertifiziert. Erhalte bis zu 100% der Kosten zurückerstattet!", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "text-danger d-flex"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "pe-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-users" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "Dieser Kurs ist aktuell leider ausgebucht. Du kannst dich aber auf die Warteliste setzen und wirst benachrichtigt, sobald ein Platz frei wird!", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.course.insurance_certified || _ctx.course.participants_limit_reached)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.classes)
      }, [
        (_ctx.course.insurance_certified)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
          : _createCommentVNode("", true),
        (_ctx.course.participants_limit_reached)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}